export interface HttpError {
  status?: number;
  data?: unknown;
}

const INACTIVE_CENTRAL = 'Customer is not active.';

// The server answers with plain pt-BR text without accents; it is matched verbatim and never shown.
const byServerText: Record<string, string> = {
  [INACTIVE_CENTRAL]: 'billingBlockInactiveCentral',
  'O bloqueio ja foi liberado': 'billingBlockErrorAlreadyReleased',
  'A central esta suspensa: o bloqueio de veiculos nao pode ser desligado': 'billingBlockErrorCentralSuspended',
  'A central dona do cliente esta suspensa': 'billingBlockErrorCentralSuspended',
  'Write access denied': 'billingBlockErrorForbidden',
  'Ja existe isencao em vigor para este cliente': 'billingBlockErrorAlreadyExemptCustomer',
  'Ja existe isencao em vigor para este veiculo': 'billingBlockErrorAlreadyExemptDevice',
  'Cliente nao encontrado': 'billingBlockErrorOtherCentral',
  'Veiculo nao encontrado': 'billingBlockErrorOtherCentral',
  'Bloqueio nao encontrado': 'billingBlockErrorNotFound',
  'Isencao nao encontrada': 'billingBlockErrorNotFound',
};

const byStatus: Record<number, string> = {
  400: 'billingBlockErrorInvalid',
  403: 'billingBlockErrorForbidden',
  404: 'billingBlockErrorNotFound',
  409: 'billingBlockErrorConflict',
};

const asHttpError = (error: unknown): HttpError => (error && typeof error === 'object' ? error as HttpError : {});

export const errorMessageId = (error: unknown) => {
  const {status, data} = asHttpError(error);
  if (!status || status >= 500) return 'billingBlockErrorUnexpected';
  const known = typeof data === 'string' ? byServerText[data.trim()] : undefined;
  return known || byStatus[status] || 'billingBlockErrorUnexpected';
};

export const isInactiveCentralError = (error: unknown) => {
  const {status, data} = asHttpError(error);
  return status === 403 && data === INACTIVE_CENTRAL;
};

export const isAlreadyExemptError = (error: unknown) => (
  ['billingBlockErrorAlreadyExemptCustomer', 'billingBlockErrorAlreadyExemptDevice'].includes(errorMessageId(error))
);
